import Axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import config from '@/config';
import { endSessionOnUnauthorized } from '@/utils/session';
import storage from '@/utils/storage';

function authRequestInterceptor(cfg: InternalAxiosRequestConfig) {
  cfg.headers = cfg.headers || {};
  const token = storage.getToken();
  if (token) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  const unlockToken = storage.getAnalyticsBaseUnlockToken();
  const url = cfg.url || '';
  if (unlockToken && url.includes('/analytics/base') && !url.includes('/analytics/base/unlock')) {
    cfg.headers['x-analytics-base-unlock'] = unlockToken;
  }
  cfg.headers.Accept = 'application/json';
  return cfg;
}

export const axios = Axios.create({
  baseURL: config.apiUrl,
});

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error instanceof AxiosError) endSessionOnUnauthorized(error);
    return Promise.reject(error);
  }
);
